import React, { useEffect, useMemo, useState } from "react";

import {
  getJobStatTableColumns,
  getUserStatTableColumns,
} from "../../helpers/tableColumns";
import {
  CurrencyDollar,
  HourglassSplit,
  Laptop,
  PersonCircle,
} from "react-bootstrap-icons";
import { Col, Row, Table } from "react-bootstrap";
import DataTable from "../common/data-table/DataTable";
import { getJobTitle } from "../../Util/jobUtil";
import { uniqueId } from "lodash";

const ViewUserDetails = ({ users }) => {
  return (
    <div className="m-1 p-1 bg-white">
      <Table className="m-0" striped>
        <thead>
          <tr>
            <th className="smallFont p-0">Name</th>{" "}
            <th className="smallFont p-0">Email</th>{" "}
            <th className="smallFont p-0">Hour</th>{" "}
            <th className="smallFont p-0">Cost</th>
          </tr>
        </thead>
        <tbody>
          {users?.map((user) => {
            return (
              <tr key={user?.user?._id}>
                {" "}
                <td align="center" className="smallFont p-0">
                  {user?.user?.name}
                </td>{" "}
                <td align="center" className="smallFont p-0">
                  {user?.user?.email}
                </td>{" "}
                <td align="center" className="smallFont p-0">
                  {user?.hours}
                </td>{" "}
                <td align="center" className="smallFont p-0">
                  {user?.cost}
                </td>{" "}
              </tr>
            );
          })}{" "}
        </tbody>
      </Table>
    </div>
  );
};

const ViewStatByJob = ({ data = [], fetchingUserStats }) => {
  const [stats, setStats] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);

  const tableColumns = useMemo(() => getJobStatTableColumns(), []);

  const userStatFields = useMemo(() => {
    const allUsers = stats.flatMap((job) => job.users);
    const distinctUserIds = new Set(allUsers.map((user) => user.user._id));

    const totalHours = allUsers
      .reduce((total, user) => total + Number(user?.hours), 0)
      .toFixed(2);
    const totalCost = allUsers
      .reduce((total, user) => total + Number(user?.cost), 0)
      .toFixed(2);

    return [
      {
        label: "Users",
        key: "userCount",
        Icon: PersonCircle,
        color: "#BC70A4",
        value: distinctUserIds.size,
      },
      {
        label: "Jobs",
        key: "jobCount",
        Icon: Laptop,
        color: "#BC70A4",
        value: stats.length,
      },
      {
        label: "Hours worked",
        key: "hour",
        Icon: HourglassSplit,
        color: "#ff8787",
        value: totalHours,
      },
      {
        label: "Cost",
        key: "cost",
        Icon: CurrencyDollar,
        color: "#51cf66",
        value: totalCost,
      },
    ];
  }, [stats]);

  const onRowClick = (row) => {
    setExpandedRow(expandedRow === row?._id ? null : row?._id);
  };
  useEffect(() => {
    setStats(data?.map((d) => ({ ...d, _id: uniqueId() })));
  }, [data]);

  return (
    <div className="mb-2 px-2 pt-1">
      {" "}
      <Row>
        <Col md={12} lg={12}>
          <h6 className="smallFont fw-bold">Summary</h6>
          <div className="d-flex gap-3">
            {userStatFields?.map(({ Icon, label, key, color, value }) => (
              <div
                key={key}
                style={{ height: 80, width: 200 }}
                className="d-flex px-2 gap-2 align-items-center rounded border hover"
              >
                {" "}
                <Icon style={{ color }} size={30} />
                <div className="flex-grow-1">
                  {" "}
                  <h6 className={`mb-0`} style={{ fontWeight: 700 }}>
                    {value}
                  </h6>
                  <h6 className="mb-0 small-text text-secondary"> {label}</h6>
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12}>
          {" "}
          <h6 className="smallFont fw-bold">Job Details</h6>
          <DataTable
            rowKey="_id"
            data={stats}
            loadingFirstPageData={fetchingUserStats}
            onRowClick={onRowClick}
            expandedRowKeys={expandedRow ? [expandedRow] : []}
            renderExpandedRow={(data) => (
              <ViewUserDetails users={data?.users} />
            )}
            columns={tableColumns}
            allowFilter={false}
            allowSort={false}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ViewStatByJob;
